const SCRIPT_SRC = 'https://checkout.razorpay.com/v1/checkout.js';

// Controlled, provider-agnostic message. Raw provider or backend error bodies
// are never surfaced for a broken order contract.
export const CHECKOUT_ORDER_INVALID_MESSAGE =
  'Payment could not be started because the order details are incomplete. No payment was attempted. Please try again or contact support.';

function isNonEmptyString(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

/**
 * Validates the exact `POST /billing/orders` response the browser needs before
 * Razorpay Checkout may be opened.
 *
 * `key_id` is the merchant account the customer will actually pay. It must come
 * from this response for every purchase — the frontend intentionally holds no
 * static Razorpay key, so a missing or malformed key stops Checkout instead of
 * silently routing the payment to a different merchant.
 */
export function isValidCheckoutOrder(order) {
  if (!order || typeof order !== 'object' || Array.isArray(order)) return false;
  if (!isNonEmptyString(order.key_id)) return false;
  if (!isNonEmptyString(order.razorpay_order_id)) return false;
  if (!Number.isInteger(order.amount_paise) || order.amount_paise <= 0) return false;
  if (!isNonEmptyString(order.currency)) return false;
  return true;
}

let loadPromise = null;

export function loadRazorpayCheckout() {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('RAZORPAY_SCRIPT_LOAD_FAILED'));
  }
  if (window.Razorpay) return Promise.resolve(window.Razorpay);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) {
        resolve(window.Razorpay);
      } else {
        loadPromise = null;
        reject(new Error('RAZORPAY_SCRIPT_LOAD_FAILED'));
      }
    };
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('RAZORPAY_SCRIPT_LOAD_FAILED'));
    };
    document.body.appendChild(script);
  });

  return loadPromise;
}
